<template>
  <section class="section section--text-banner">
    <div class="r">
      <p class="p-1" data-test="text-banner">{{ __TT(bannerText) }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TextBanner',
  props: {
    bannerText: {
      type: String,
      required: true,
    },
  },
};
</script>
